var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeviceManagementIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.667C10.6903 16.667 11.25 16.1073 11.25 15.417C11.25 14.7267 10.6903 14.167 10 14.167C9.30967 14.167 8.75 14.7267 8.75 15.417C8.75 16.1073 9.30967 16.667 10 16.667Z",
    fill: "#1C1B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 16.6663C2.5 18.1481 3.83389 19.1663 5.23809 19.1663H14.7619C16.1661 19.1663 17.5 18.1481 17.5 16.6663V3.33301C17.5 1.85125 16.1661 0.833008 14.7619 0.833008H5.23809C3.83389 0.833008 2.5 1.85125 2.5 3.33301V16.6663ZM5.23809 17.4997C4.53836 17.4997 4.16667 17.0255 4.16667 16.6663V3.33301C4.16667 2.97382 4.53836 2.49967 5.23809 2.49967H14.7619C15.4617 2.49967 15.8333 2.97382 15.8333 3.33301V16.6663C15.8333 17.0255 15.4617 17.4997 14.7619 17.4997H5.23809Z",
    fill: "#1C1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceManagementIcon);
export default __webpack_public_path__ + "static/media/device_management_icon.57ce3f623795ffa9127907a5d46cf4b9.svg";
export { ForwardRef as ReactComponent };